import { render, staticRenderFns } from "./CertificateModal.vue?vue&type=template&id=e5ea2e36&scoped=true&"
import script from "./CertificateModal.vue?vue&type=script&lang=js&"
export * from "./CertificateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ea2e36",
  null
  
)

export default component.exports